<template>
  <div>
    <mroHeaderVue v-if="!isHideHeaderFooter" />
    <ad />
    <keep-alive :include="routerStores.cachedViews">
      <router-view />
    </keep-alive>
    <rightSildeVue v-if="!isHideHeaderFooter" />
    <mrofooterVue v-if="!isHideHeaderFooter" />
  </div>
</template>
<script setup lang="ts">
import mroHeaderVue from './components/mroHeader.vue';
import mrofooterVue from './components/mrofooter.vue';
import rightSildeVue from './components/rightSilde.vue';
import ad from './components/ad.vue';
import { usePermissionStore } from '@/stores/routers';
const routerStores = usePermissionStore();
// 门户iframe 隐藏头部和底部 侧边栏
const isHideHeaderFooter = sessionStorage.getItem('isHideHeaderFooter');
</script>
